module.exports = {"items":[{"name":"Home","txt":"m_page_intro","class":"p-intro"},{"name":"Oversight","txt":"m_page_over","class":"p-oversight"},{"name":"Improvement","txt_over":"part_1","txt":"p_1_right_menu","class":"p-imp"},{"name":"Dementia","txt_over":"part_2","txt":"p_1_left_menu","class":"p-dem"},{"name":"Material","txt_over":"part_3","txt":"p_3_left_menu","class":"p-mat"},{"name":"Recourses","txt_over":"","txt":"recourses","class":"p-res"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/menu.json
// module id = oZCe
// module chunks = 1